import { useContext } from 'react';

import { Text, useDisclosure } from '@chakra-ui/react';

import {
  TagSlugEnum,
  useMediaQuery,
  useOnTagsCreatedSubscription,
  useOnTagsDeletedSubscription,
} from '../../gql/generated/graphql';

import InfoCardV2 from '../InfoCard/InfoCardV2';
import DealTags from '../shared/DealTags';

import EditTags from './EditTags';

import { DealActionsEnum, DealContext } from '../../libs/DealContext';
import { NotesContext } from '../../libs/contextLib';
import { filterDeletedTags, mergeCreatedTags } from '../../utils/tags';

const TagInfo = () => {
  const { deal, dispatch } = useContext(DealContext);
  const { notesRefetch } = useContext(NotesContext);

  const disclosureProps = useDisclosure();

  const { refetch: mediaRefetch } = useMediaQuery({
    skip: !deal.id,
    variables: {
      dealId: deal.id ?? -1,
    },
    fetchPolicy: 'cache-and-network',
  });

  useOnTagsCreatedSubscription({
    skip: !deal.id,
    variables: { dealId: deal.id ?? -1 },
    onData: async ({ data: { data } }) => {
      if (!data?.onTagsCreated) {
        return;
      }

      const currentTags = deal.tags ?? [];
      const newTags = mergeCreatedTags(currentTags, data.onTagsCreated.tags);

      // Refetch the media and notes if the `ROI Signed` tag is added.
      if (
        !currentTags.some((tag) => tag.slug === TagSlugEnum.RoiSigned) &&
        newTags.some((tag) => tag.slug === TagSlugEnum.RoiSigned)
      ) {
        await Promise.all([mediaRefetch(), notesRefetch()]);
      }

      dispatch({
        // Don't use `DeepUpdateDeal` here. It merges the arrays instead of replacing them.
        type: DealActionsEnum.UpdateDeal,
        payload: { tags: newTags },
      });
    },
  });

  useOnTagsDeletedSubscription({
    skip: !deal.id,
    variables: { dealId: deal.id ?? -1 },
    onData: async ({ data: { data } }) => {
      if (!data?.onTagsDeleted) {
        return;
      }

      const newTags = filterDeletedTags(deal.tags, data.onTagsDeleted.tags);

      dispatch({
        // Don't use `DeepUpdateDeal` here. It merges the arrays instead of replacing them.
        type: DealActionsEnum.UpdateDeal,
        payload: { tags: newTags },
      });
    },
  });

  return (
    <>
      <InfoCardV2 name="Deal Tags" showEditable editAction={() => disclosureProps.onOpen()}>
        {!deal?.tags?.length ? <Text>No Tags</Text> : <DealTags tags={deal.tags} fontSize={12} />}
      </InfoCardV2>
      <EditTags disclosureProps={disclosureProps} />
    </>
  );
};

export default TagInfo;
